export type FlowLayoutPreset = 'mobile' | 'tablet' | 'desktop';

export const FLOW_LAYOUT_BREAKPOINTS = {
  mobile: 521,
  desktop: 768,
} as const;

export const getFlowLayoutPreset = (width: number): FlowLayoutPreset => {
  if (width < FLOW_LAYOUT_BREAKPOINTS.mobile) {
    return 'mobile';
  }
  if (width < FLOW_LAYOUT_BREAKPOINTS.desktop) {
    return 'tablet';
  }
  return 'desktop';
};

export const getCurrentFlowLayoutPreset = (): FlowLayoutPreset => {
  if (typeof window === 'undefined') {
    return 'desktop';
  }
  return getFlowLayoutPreset(window.innerWidth);
};

